import { Component, Input, OnInit } from '@angular/core';
import { ReplaySubject } from 'rxjs';
import { AppValidators } from 'src/app/common/appValidators';
import { FilterTypesEnum } from 'src/app/models/filters/filterTypes.enum';
import { HygieneFiltersModel } from 'src/app/models/filters/implementations/pageFilters/hygieneFilters.model';
import { ISelectOption } from 'src/app/models/selectOptions';

@Component({
  selector: 'app-hygiene-filters',
  templateUrl: './hygiene-filters.component.html',
  styleUrls: ['./hygiene-filters.component.scss'],
})
export class HygieneFiltersComponent implements OnInit {
  @Input() public pageFilters: HygieneFiltersModel;

  public selectedOptions: ISelectOption[] = [];

  public searchBoxNewValue = new ReplaySubject<string | undefined>(1);
  public fromDateNewValue = new ReplaySubject<Date | undefined>(1);
  public toDateNewValue = new ReplaySubject<Date | undefined>(1);

  public searchValidators = [AppValidators.evenNumberOfQuoteMarks];

  ngOnInit(): void {
    this.pageFilters.onUpdate$.subscribe((data) => {
      this.selectedOptions = this.pageFilters.getAllSelectedOptions();

      this.searchBoxNewValue.next(data.search);
      this.fromDateNewValue.next(data.fromDate);
      this.toDateNewValue.next(data.toDate);
    });
  }

  public fromDateSelected(value?: Date): void {
    this.pageFilters.updateFilterFromUserSelection(FilterTypesEnum.FromDate, value);
  }

  public toDateSelected(value?: Date): void {
    this.pageFilters.updateFilterFromUserSelection(FilterTypesEnum.ToDate, value);
  }

  public searchSubmitted(value?: string): void {
    this.pageFilters.updateFilterFromUserSelection(FilterTypesEnum.Search, value);
  }
}
